import {
   createOrgGuard,
   orgGuard,
   subscriptionProjectGuard,
} from "../guards/composable"
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import OnboardingHome from "../../views/onboarding/OnboardingHome.vue"
import SelectSubscription from "../../views/onboarding/SelectSubscription.vue"
import { CreateOrg } from "@views/onboarding"

export default [
   {
      path: "/onboarding/create-org",
      name: "OnboardingCreateOrg",
      component: CreateOrg,
      meta: {
         layout: "AppLayoutDefault", // should be OnboardingLayout so that users can log out, but there's a spacing issue
      },
      beforeEnter: createOrgGuard,
   },
   {
      path: "/onboarding/select-subscription",
      name: "SelectSubscription",
      component: SelectSubscription,
      meta: {
         layout: "OrgsLayout",
      },
      beforeEnter: async (
         to: RouteLocationNormalized,
         from: RouteLocationNormalized,
         next: NavigationGuardNext,
      ) => {
         // Ensure user has an active org before selecting subscription
         // This handles the case where user created org but abandoned checkout
         const { setOnlyOrgAsActive, getNumberOfOrgs } = await import("@/services/clerk")
         const numOrgs = await getNumberOfOrgs()
         
         if (numOrgs === 0) {
            // No orgs at all - send to create org
            return next({ name: "OnboardingCreateOrg" })
         }
         
         if (numOrgs === 1) {
            // Ensure the single org is set as active
            await setOnlyOrgAsActive()
         }
         
         // Now run the standard org guard to validate
         return orgGuard(to, from, next)
      },
   },
   {
      name: "OnboardingHome",
      path: "/orgs/:orgSlug/projects/:projectId/onboarding",
      component: OnboardingHome,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
]
